import 'owl.carousel/dist/assets/owl.carousel.css!';
import 'owl.carousel';
import $ from 'jquery';

class Agenda {
    constructor(){
        this.buttonActionPLus = jQuery('.home-agenda__item__title__plus');
        this.slider_agenda = jQuery('[data-component="slider__agenda"]');
        this._init();
    }

    _init(){        
        document.addEventListener('DOMContentLoaded', (event) => {
            this.buttonActionPLus.on('click',function(){
                var idContent = jQuery(this).attr('data--plus');
                if(jQuery('.agenda__contenu_'+idContent).css("display") == "block"){
                    jQuery('.agenda__contenu_'+idContent).css('display','none');
                } else {
                    jQuery('.agenda__contenu_'+idContent).css('display','block');
                }
                return false;
            });
        });
        
        document.addEventListener('DOMContentLoaded', (event) => {
            if(this.slider_agenda[0]){
                this.slider_agenda.owlCarousel({
                    items:             1,
                    navigation:        true,
                    navText:          ['',''],
                    dots:              false,
                    navContainerClass: 'owl-nav-agenda',
                    onTranslated:      this.updateNav.bind(this),
                    autoPlay:          4000,
                    slideSpeed:        400,
                    autoHeight:         false
                });
            }
        });
        
        $('.agenda__contenu').map(function(){
            $(this).css('display','none');
        });
    }
    
    /**
   * Change l'état actif de la navigation du carousel
   * en fonction de l'index de la slide active
   */
  updateNav(event){
    $(this.navItems).attr('data-state', 'inactive');
    $(this.navItems).eq(event.item.index).attr('data-state', 'active');
    if( (event.item.index+1) === event.item.count ) {
      setTimeout( ()=>this.slider.trigger( 'to.owl.carousel', 0 ), 8000 );
    }
  }

  /**
   * Change la slide en fonction de l'index passé en paramètre
   * Change l'état actif de la navigation du carousel en fonction de l'index passé en paramètre
   */
  updateCarousel( index ){
    $(this.navItems).attr('data-state', 'inactive');
    $(this.navItems).eq(index).attr('data-state', 'active');
    this.slider.trigger( 'to.owl.carousel', [index] );
  }
}

export let agenda = new Agenda();